import React, { Fragment } from 'react';
import Header from '../../theme-components/Header/Header';
import Footer from '../../components/Footer/Footer';

const ComponentWithoutSideNav = ({ component: Component, ...rest }) => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <Header />
      <div className="app-main" style={{ flex: '1 0 auto' }}>
        <div className="app-main__inner">
          <Component {...rest} />
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ComponentWithoutSideNav;